import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setEasyWalkThroughFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};

const setEasyWalkThroughFormNextStep = (state, { payload }) => {
  return {
    ...state,
    step: state.step + 1,
    // step:  1,
  };
};

const setEasyWalkThroughFormPreviousStep = (state, { payload }) => {
  return {
    ...state,
    step: state.step - 1,
  };
};

const setEasyWalkThroughFormStep = (state, { payload }) => {
  return {
    ...state,
    step: payload.step,
  };
};

const exitEasyWalkThroughForm = (state) => {
  return {
    isVisible: false,
    step: 0,
    data: {},
  };
};

// const setEasyWalkThroughFormIsVisible = (state, { payload }) => {
//   return {
//     ...state,
//     isVisible: payload,
//   };
// };

const initialState = {
  step: 0,
};

export default createReducer(initialState, {
  [TYPES.EXIT_EASY_WALK_THROUGH_FORM]: exitEasyWalkThroughForm,
  [TYPES.SET_EASY_WALK_THROUGH_FORM_DATA]: setEasyWalkThroughFormData,
//   [TYPES.SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE]: setEasyWalkThroughFormIsVisible,
  [TYPES.SET_EASY_WALK_THROUGH_FORM_NEXT_STEP]: setEasyWalkThroughFormNextStep,
  [TYPES.SET_EASY_WALK_THROUGH_FORM_PREVIOUS_STEP]: setEasyWalkThroughFormPreviousStep,
  [TYPES.SET_EASY_WALK_THROUGH_FROM_STEP]: setEasyWalkThroughFormStep
});
